import {
  findAvailableClientCredentials,
  updateCorporateClientCredential,
} from '../../../api/corporateApi'
import translate from '../../../i18n'
import {
  IClientCredential,
  ICorporate,
  ICorporateClientCredential,
} from '../../../pages/corporates-container/share-type'
import styles from '../credits-notes-form/credits-notes-form.module.less'
import { Button, DatePicker, Form, Modal, notification, Select, Space } from 'antd'
import dayjs from 'dayjs'
import { useEffect, useState } from 'react'

interface IProps {
  visible: boolean
  corporate: ICorporate
  corporateClientCredential?: ICorporateClientCredential
  onCancel: () => void
  onSubmit: () => void
}

const { Option } = Select

const CorporateClientCredentialModal = (props: IProps) => {
  const { visible, corporate, corporateClientCredential, onCancel, onSubmit } = props
  const [loading, setLoading] = useState<boolean>(false)
  const [clientCredentials, setClientCredentials] = useState<IClientCredential[]>()

  const [form] = Form.useForm()

  useEffect(() => {
    findAvailableClientCredentials().then(res => {
      if (corporateClientCredential) {
        res.push(corporateClientCredential.clientCredential)
        form.setFieldsValue({
          clientCredentialId: corporateClientCredential.clientCredential.id,
          maxCreditsExpiredAt: corporateClientCredential.maxCreditsExpiredAt
            ? dayjs(corporateClientCredential.maxCreditsExpiredAt)
            : undefined,
        })
      }
      setClientCredentials(res)
    })
  }, [corporate, corporateClientCredential, visible])

  const onFinish = (value: any) => {
    if (!corporate) {
      return
    }
    setLoading(true)
    updateCorporateClientCredential({
      ...value,
      maxCreditsExpiredAt: value.maxCreditsExpiredAt.toISOString(),
      corporateId: corporate.id,
    })
      .then(() => {
        notification.success({
          message: translate('corporate.corporateClientCredential'),
          description: translate('corporate.corporateClientCredential.updateSuccess'),
        })
        onSubmit()
      })
      .catch(err => {
        notification.error({
          message: translate('corporate.corporateClientCredential'),
          description:
            err?.message || translate('corporate.corporateClientCredential.updateFailed'),
        })
      })
      .finally(() => {
        setLoading(false)
        onCancel()
      })
  }

  return (
    <Modal
      centered
      open={visible}
      footer={null}
      width={800}
      forceRender
      title={translate('corporate.corporateClientCredential')}
      onCancel={onCancel}
    >
      <Form
        layout="horizontal"
        name="corporate-client-credential-form"
        labelCol={{ span: 8 }}
        wrapperCol={{ span: 10 }}
        onFinish={onFinish}
        autoComplete="off"
        form={form}
      >
        <Form.Item
          label={translate('corporate.corporateClientCredential.clientCredential')}
          name="clientCredentialId"
          rules={[
            {
              required: true,
            },
          ]}
        >
          <Select>
            {clientCredentials?.map(item => (
              <Option key={item.id} value={item.id}>
                {item.name}
              </Option>
            ))}
          </Select>
        </Form.Item>
        <Form.Item
          label={translate('corporate.corporateClientCredential.maxCreditsExpiredAt')}
          name="maxCreditsExpiredAt"
          rules={[{ required: true }]}
        >
          <DatePicker
            format="YYYY-MM-DD HH:mm:ss"
            showTime
            disabledDate={current => {
              return current && current.isBefore(dayjs().startOf('minute'))
            }}
          />
        </Form.Item>
        <Form.Item label=" " colon={false}>
          <Space className={styles['button-group']}>
            <Button loading={loading} type="primary" htmlType="submit">
              {translate('submit')}
            </Button>
            <Button onClick={onCancel}>{translate('cancel')}</Button>
          </Space>
        </Form.Item>
      </Form>
    </Modal>
  )
}

export default CorporateClientCredentialModal
